<script setup lang="ts">
import { onMounted, ref } from 'vue'
import anhMatTruoc from '@/assets/images/mattruoc.png'
import anhMatSau from '@/assets/images/matsau.jpg'
import moment from 'moment'
import { toPng, toJpeg, toSvg } from 'html-to-image'
import download from 'downloadjs'

const data = ref<any>({
  so_cccd: '',
  fullname: '',
  dob: '',
  sex: '',
  quequan: '',
  thuongtru: '',
  exp: ''
})

const matTruocRef = ref<HTMLDivElement | null>(null)
const matSauRef = ref<HTMLDivElement | null>(null)

const randomData = () => {
  const getRandomNumber = (length: number) =>
    Array.from({ length }, () => Math.floor(Math.random() * 10)).join('')

  const ho = ['Nguyễn', 'Trần', 'Lê', 'Phạm', 'Hoàng', 'Vũ', 'Đặng', 'Bùi']
  const tenDemNam = ['Văn', 'Hữu', 'Đức', 'Minh', 'Quang', 'Trọng', 'Thành', 'Công']
  const tenDemNu = ['Thị', 'Ngọc', 'Thuỳ', 'Mai', 'Diễm', 'Bích', 'Thanh', 'Phương']
  const tenNam = ['Nam', 'Huy', 'Tuấn', 'Khang', 'Dũng', 'Long', 'Bảo']
  const tenNu = ['Lan', 'Hương', 'Trang', 'Mai', 'Linh', 'Vy', 'Ngân']

  const diaGioiDaNang: Record<string, string[]> = {
    'Quận Hải Châu': ['Phường Hải Châu 1', 'Phường Hải Châu 2', 'Phường Thạch Thang', 'Phường Nam Dương'],
    'Quận Thanh Khê': ['Phường An Khê', 'Phường Chính Gián', 'Phường Tam Thuận'],
    'Quận Sơn Trà': ['Phường An Hải Bắc', 'Phường An Hải Đông', 'Phường An Hải Tây'],
    'Quận Ngũ Hành Sơn': ['Phường Mỹ An', 'Phường Khuê Mỹ', 'Phường Hòa Hải'],
    'Quận Liên Chiểu': ['Phường Hòa Minh', 'Phường Hòa Khánh Bắc', 'Phường Hòa Khánh Nam'],
    'Quận Cẩm Lệ': ['Phường Khuê Trung', 'Phường Hòa Thọ Đông', 'Phường Hòa An'],
    'Huyện Hòa Vang': ['Xã Hòa Nhơn', 'Xã Hòa Phong', 'Xã Hòa Tiến']
  }

  const random = <T>(arr: T[]): T => arr[Math.floor(Math.random() * arr.length)]

  const sex = Math.random() > 0.5 ? 'Nam' : 'Nữ'
  const ten = sex === 'Nam' ? random(tenNam) : random(tenNu)
  const tenDem = sex === 'Nam' ? random(tenDemNam) : random(tenDemNu)
  const fullname = `${random(ho)} ${tenDem} ${ten}`

  const dob = new Date()
  dob.setFullYear(dob.getFullYear() - (18 + Math.floor(Math.random() * 22))) // 18–40 tuổi
  dob.setMonth(Math.floor(Math.random() * 12))
  dob.setDate(Math.floor(Math.random() * 28) + 1)

  const exp = new Date()
  exp.setFullYear(exp.getFullYear() + Math.floor(Math.random() * 10) + 1)
  exp.setMonth(Math.floor(Math.random() * 12))
  exp.setDate(Math.floor(Math.random() * 28) + 1)

  const quanHuyen = random(Object.keys(diaGioiDaNang))
  const xaPhuong = random(diaGioiDaNang[quanHuyen])
  const diaChi = `${xaPhuong}, ${quanHuyen}, TP. Đà Nẵng`

  data.value = {
    so_cccd: `04909000${getRandomNumber(4)}`,
    fullname,
    dob: moment(dob).format('DD/MM/YYYY'),
    sex,
    quequan: diaChi,
    thuongtru: diaChi,
    exp: moment(exp).format('DD/MM/YYYY'),
  }
}


const handleDownloadMatTruoc = async () => {
  if(matTruocRef.value){
    const dataUrl = await toPng(matTruocRef.value)
    download(dataUrl, `mat-truoc_${data.value.so_cccd}.png`);
  }
}

const handleDownloadMatSau = async () => {
  if(matSauRef.value){
    const dataUrl = await toPng(matSauRef.value)
    download(dataUrl, `mat-sau_${data.value.so_cccd}.png`);
  }
}

onMounted(() => {
  randomData()
})
</script>


<template>
<div class="flex flex-col w-[800px] p-3">
  <div class="flex">
    <div class="flex-1">CCCD</div>
    <div class="flex-2">
      <InputText class="form-control" type="text" v-model="data.so_cccd"/>
    </div>
  </div>
  <div class="flex">
    <div class="flex-1">Họ và tên</div>
    <div class="flex-2">
      <InputText class="form-control" type="text" v-model="data.fullname"/>
    </div>
  </div>
  <div class="flex">
    <div class="flex-1">Ngày sinh</div>
    <div class="flex-2">
      <InputText class="form-control" type="text" v-model="data.dob"/>
    </div>
  </div>
  <div class="flex">
    <div class="flex-1">Giới tính</div>
    <div class="flex-2">
      <InputText class="form-control" type="text" v-model="data.sex"/>
    </div>
  </div>
  <div class="flex">
    <div class="flex-1">Quê quán</div>
    <div class="flex-2">
      <InputText class="form-control" type="text" v-model="data.quequan"/>
    </div>
  </div>
  <div class="flex">
    <div class="flex-1">Thường trú</div>
    <div class="flex-2">
      <InputText class="form-control" type="text" v-model="data.thuongtru"/>
    </div>
  </div>
  <div class="flex">
    <div class="flex-1">Ngày hết hạn</div>
    <div class="flex-2">
      <InputText class="form-control" type="text" v-model="data.exp"/>
    </div>
  </div>
</div>
  <button class="btn btn-cs" @click="handleDownloadMatTruoc">Download ảnh mặt trước</button>
  <div class="mattruoc mb-3" ref="matTruocRef">
    <img :src="anhMatTruoc"/>
    <div class="field socccd"><span></span>{{data.so_cccd}}</div>
    <div class="field fullname"><span></span>{{data.fullname.toUpperCase()}}</div>
    <div class="field dob"><span></span>{{data.dob}}</div>
    <div class="field sex"><span></span>{{data.sex}}</div>
    <div class="field quequan"><span></span>{{data.quequan}}</div>
    <div class="field thuongtru"><span></span>{{data.thuongtru}}</div>
    <div class="field exp"><span></span>{{data.exp}}</div>
  </div>
  <button class="btn btn-cs" @click="handleDownloadMatSau">Download ảnh mặt sau</button>
  <div class="matsau" ref="matSauRef">
    <img :src="anhMatSau"/>
  </div>
</template>

<style lang="scss">
.mattruoc{
  width: 680px;
  height: 430px;
  background: #1f2937;
  position: relative;
  .field{
    position: absolute;
    background-color: transparent;
    font-weight: 400;
    font-size: 20px;
  }
  .socccd{
    top: 175px;
    left: 280px;
    width: 100%;
    height: 100%;
    font-weight: bold;
    font-size: 24px;
  }
  .fullname{
    top: 230px;
    left: 280px;
    width: 100%;
    height: 100%;
  }
  .dob{
    top: 253px;
    left: 390px;
    width: 100%;
    height: 100%;
  }
  .sex{
    top: 280px;
    left: 315px;
    width: 100%;
    height: 100%;
  }
  .thuongtru{
    top: 355px;
    line-height: 24px;
    left: 233px;
    width: 400px;
    height: 100%;
    span{
      width: 250px;
      display: inline-block;
    }
  }
  .quequan{
    line-height: 24px;
    top: 310px;
    left: 233px;
    width: 400px;
    height: 100%;
    span{
      width: 180px;
      display: inline-block;
    }
  }
  .exp{
    top: 370px;
    left: 115px;
    width: 100%;
    height: 100%;
    font-size: 13px;
  }
}
.matsau{
  width: 680px;
  height: 430px;
}
</style>
